import React from "react";
import { Form as FormLayout, Modal } from "react-bootstrap";
import { useUpdateExchangeRateMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Form, Formik } from "formik";
import * as Yup from "yup"
import TextInput from "../../../Common/components/text-input"

const EditExchangeRateModal = ({ showEditExchangeRateModal, onHide, details }) => {
    const [
        updateExchangeRate, // This is the mutation trigger
        { isLoading: isUpdating }, // This is the destructured mutation result
    ] = useUpdateExchangeRateMutation()

    /* Update Exchange Rate */
    const onSubmit = ({ rate: newRate }) => {
        const {
            id,
            fromCurrency,
            toCurrency,
            userGroup,
            rate,
        } = details

        updateExchangeRate({
            id,
            fromCurrency,
            toCurrency,
            rate: newRate,
            meta: {
                fromCurrency,
                toCurrency,
                userGroup,
                rate,
            },
        })
            .unwrap()
            .then(() => {
                cogoToast.success("Created 'Exchange Rate Update' Action Successfully")
                onHide();
            })
    }

    return (
        <Modal
            show={showEditExchangeRateModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={details}
                validationSchema={Yup.object({
                    rate: Yup.number().required("required")
                })}
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update Exchange Rate
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <TextInput
                                label={`${details?.fromCurrency} to ${details?.toCurrency} Rate*`}
                                name="rate"
                                type="number"
                                step="any"
                                shouldShowError={true}
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isUpdating}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isUpdating}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Update
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal>
    );
}

export default EditExchangeRateModal;
